import ReactMarkdown from 'react-markdown';
import { ICommunication } from 'types';
import remarkGfm from 'remark-gfm';
import Communication from './communication';

const CommunicationContainer = (communication: ICommunication) => {
  return (
    <div>
      <Communication
        communicationId={communication.communicationId}
        title={communication.title}
        choice={communication.choice}
        content={
          <ReactMarkdown
            children={communication.content.toString()}
            remarkPlugins={[remarkGfm]}
          />
        }
      />
    </div>
  );
};

export default CommunicationContainer;
